export default "__VITE_ASSET__f3293dcb__"